import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useLenis, { scrollToId } from "@/hooks/useLenis";
import { ReserveProvider } from "@/components/landing/Reserve";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Ribbon } from "@/components/landing/Ribbon";
import { Problem } from "@/components/landing/Problem";
import { Philosophy } from "@/components/landing/Philosophy";
import { Assessment } from "@/components/landing/Assessment";
import { SevenDays } from "@/components/landing/SevenDays";
import { Guide } from "@/components/landing/Guide";
import { WhoFor } from "@/components/landing/WhoFor";
import { Output } from "@/components/landing/Output";
import { Reset } from "@/components/landing/Reset";
import { MeetBrian } from "@/components/landing/MeetBrian";
import { Founding50 } from "@/components/landing/Founding50";
import { FAQ } from "@/components/landing/FAQ";
import { Closing, Footer } from "@/components/landing/Closing";

export default function LandingPage() {
  useLenis();
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 400);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <ReserveProvider>
      <main data-testid="landing-page" className="relative bg-cream text-ink antialiased">
        <div className="grain-fixed" aria-hidden />
        <Nav />
        <Hero />
        <Ribbon />
        <Problem />
        <Philosophy />
        <Assessment />
        <SevenDays />
        <Guide />
        <WhoFor />
        <Output />
        <Reset />
        <MeetBrian />
        <Ribbon dark />
        <Founding50 />
        <FAQ />
        <Closing />
        <Footer />
      </main>
    </ReserveProvider>
  );
}
